// extracted by mini-css-extract-plugin
module.exports = {"bookingInfoWrapper":"ChildConfirmationView_bookingInfoWrapper__2RZ37","confirmationInfo":"ChildConfirmationView_confirmationInfo__31W9K","info":"ChildConfirmationView_info__WWOsR"};